/**
 * Où PostHog s'allume, et par où il envoie.
 *
 * Seuls les deux services Render envoient : un build servi ailleurs (QA,
 * recette sur localhost:3000…) n'est pas en mode `development` et envoyait
 * jusqu'ici des milliers d'événements mêlés à ceux des vrais utilisateurs.
 *
 * L'envoi passe par le relais du serveur (server/routes/relais-analytique.routes.js) :
 * même origine que la page, donc permis par la CSP et invisible aux bloqueurs.
 */

/** Hôte de la page → environnement posé sur chaque événement (filtre des replays). */
export const HOTES_POSTHOG = Object.freeze({
  'alertis-back-office.onrender.com': 'production',
  'alertis-back-office-staging.onrender.com': 'staging',
})

export const CHEMIN_RELAIS = '/relais'

// L'interface de PostHog, pour les liens qu'il fabrique (barre d'outils…) : le
// relais ne sert que l'envoi.
export const UI_HOST_POSTHOG = 'https://eu.posthog.com'

/**
 * @param {string} [hote] `window.location.hostname`
 * @returns {'production'|'staging'|null} null : PostHog reste éteint
 */
export function environnementPostHog(hote) {
  if (typeof hote !== 'string') return null
  return Object.prototype.hasOwnProperty.call(HOTES_POSTHOG, hote) ? HOTES_POSTHOG[hote] : null
}

/** L'adresse d'envoi de posthog-js : le relais, sur l'origine de la page. */
export function adresseRelais(origine) {
  return `${String(origine || '').replace(/\/+$/, '')}${CHEMIN_RELAIS}`
}
